// Should stay in sync with supplementalRoles.mjs
export default {
  ATL: 1,
  ATM: 2
};
